exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".operation-buttons[data-v-ead34dce] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 20px;\n}\n.operation-buttons .el-button[data-v-ead34dce] {\n  margin: 0 10px;\n}", ""]);

// exports
